module.exports = __webpack_public_path__ + "img/logo_new.f25d08cd.png";